var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.98 2.694C1.258.632 3.074-.53 5.007.24c1.218.485 2.815 1.213 4.87 2.305a59.02 59.02 0 014.666 2.735c2.106 1.38 2.106 4.062 0 5.443a59.267 59.267 0 01-4.665 2.735c-2.056 1.091-3.653 1.819-4.871 2.304-1.933.77-3.75-.393-4.029-2.455A39.603 39.603 0 01.635 8c0-2.119.155-3.909.344-5.306z",
    fill: "#1253FA"
  })));
}
export default SvgPlay;